<template>
  <div>
    <a-card :bordered="false">
      <div class="queryView">
        <div class="queryView-conditions">
          <a-form layout="inline" :form="form" class="form-label-4">
            <a-form-item label="项目">
              <a-select
                class="form-control lg"
                v-decorator="['projectCode']"
                placeholder="请选择"
                allowClear
                showSearch
                :options="projectList"
                :filterOption="filterByPY"
              ></a-select>
            </a-form-item>
            <a-form-item label="身份证号">
              <a-input class="form-control" v-decorator="['cardId']" placeholder="请输入身份证号" allowClear></a-input>
            </a-form-item>
            <a-form-item label="日期">
              <a-range-picker v-decorator="['date']" />
            </a-form-item>
            <a-form-item>
              <div class="condition-btns">
                <a-button type="primary" @click="doQuery(1)">查询</a-button>
                <a-button type="default" @click="resetAndQuery">重置</a-button>
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="queryView-actions">
          <a-upload name="file" @change="handleUploadChange" :beforeUpload="beforeUpload" :customRequest="doUpload">
            <template>
              <a-button>
                <a-icon type="upload" />
                批量导入
              </a-button>
              <a @click.stop="download">
                <a-icon type="download"></a-icon>
                模板下载
              </a>
            </template>
          </a-upload>
        </div>

        <div class="queryView-main">
          <a-table
            class="queryView-table"
            rowKey="id"
            bordered
            :loading="loading"
            :columns="tableColumns"
            :dataSource="dataSource"
            :pagination="false"
            size="middle"
          ></a-table>
          <base-pagination
            :totalCount.sync="totalCount"
            :pageNo.sync="pageNo"
            :pageSize.sync="pageSize"
            @change="pageChange"
            size="small"
          />
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { queryViewMixin } from '@/utils/mixin'
import { getProjectList } from '@/service/getData'
import fileDownload from 'js-file-download'
import axios from 'axios'

export default {
  mixins: [queryViewMixin],

  data() {
    const tableColumns = [
      {
        title: '项目名称',
        width: '15%',
        align: 'center',
        dataIndex: 'projectName',
      },
      {
        title: '项目编码',
        width: '6%',
        align: 'center',
        dataIndex: 'projectCode',
      },
      {
        title: '名称',
        width: '6%',
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: '身份证号码',
        width: '15%',
        align: 'center',
        dataIndex: 'cardId',
      },

      {
        title: '方向',
        width: '6%',
        align: 'center',
        dataIndex: 'attendanceType',
        customRender: text => {
          return <div>{this.translateType(text, 'attendanceType')}</div>
        },
      },
      {
        title: '考勤日期',
        width: '8%',
        align: 'center',
        dataIndex: 'attendanceDate',
      },
      {
        title: '考勤时间',
        width: '12%',
        align: 'center',
        dataIndex: 'attendanceTime',
      },
      {
        title: '状态',
        width: '6%',
        align: 'center',
        dataIndex: 'status',
        customRender: (text, row, index) => {
          return <span>{this.translateType(text, 'status')}</span>
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableColumns: tableColumns,
      dataSource: [],

      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },

      projectList: [],
    }
  },
  computed: {
    typesMap() {
      return {
        status: [
          { value: 1, label: '有效考勤' },
          { value: 2, label: '单边考勤' },
          { value: 3, label: '冗余考勤' },
        ],
        attendanceType: [
          { value: '0', label: '进场' },
          { value: '1', label: '出场' },
        ],
      }
    },
  },
  methods: {
    async doQuery(_pageNo = this.pageNo, _pageSize = this.pageSize) {
      this.loading = true
      try {
        const res = await this.$axios.post('/attendance/web/attendance/detail/list', {
          ...this.formatTimeRangeParams(this.getPageParams(_pageNo, _pageSize), 'date', {
            format: 'YYYY-MM-DD',
          }),
        })
        const { pageSize, pageNo, totalCount, list } = res.data
        this.totalCount = totalCount
        this.pageSize = pageSize
        this.pageNo = pageNo
        this.dataSource = list
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    async download() {
      const sourceSrc = 'https://van-tai-statics.oss-cn-hangzhou.aliyuncs.com/worker/考勤补录.xlsx'
      const serverRes = await axios.get(sourceSrc, { responseType: 'blob' })
      fileDownload(serverRes.data, '考勤补录.xlsx')
    },
    beforeUpload(file) {
      const maxFileSize = 10
      const isLtSize = file.size / 1024 / 1024 < maxFileSize
      if (!isLtSize) {
        this.$message.error(`上传文件不能大于${maxFileSize}M!`)
        return false
      }
    },
    async handleUploadChange({ file, fileList }) {
      if (file.status === 'done') {
        this.$message.success(`${file.name} 上传成功，稍后可查看补录结果`)
        this.doQuery(1)
      } else if (file.status === 'error') {
        console.log(file)
      }
    },
    doUpload(ev) {
      const { file, onError, onProgress, onSuccess } = ev
      this.$axios
        .post(
          '/attendance/excel/analysis',
          { file: file },
          {
            postDataType: 'formData',
            onUploadProgress: function(progressEvent) {
              onProgress(
                {
                  percent: progressEvent.lengthComputable ? progressEvent.loaded / progressEvent.total : 1,
                },
                file
              )
            },
          }
        )
        .then(() => {
          // 第一个参数会回写到 file的response
          onSuccess({}, file)
        })
        .catch(e => {
          // console.log(e)
          // 第二个参数会回写到response,response 为字符串时，会直接展示为错误提示
          onError(e, `上传失败：${e.message}`)
        })
    },
  },
  async mounted() {
    this.projectList = await getProjectList()
  },
}
</script>

<style lang="less" scoped></style>
